import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class AddStaffLeave extends React.Component {
    state = {
        visible: true,
        loading: false,
        allUsers: [],
        leaveTypes: [],
        shortLeave: false,
        endDate: null,
        startDate: null
    }

    componentDidMount() {
        const { users } = this.props;
        this.setState({ allUsers: users })
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    fetchLeaveTypes = async (date) => {
        let { form: { getFieldValue } } = this.props;
        let data = {
            month: moment(date, 'YYYY-MM-DD').format('YYYY-MM'),
            userId: getFieldValue('userId'),
        }
        let response = await Request.getLeaveTypes(data);
        this.setState({ leaveTypes: response });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let user = this.state.allUsers.find(x => x._id === values.userId)
                values.employeeName = user.display;
                let response = await Request.applyLeave(values)
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: response.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.msg
                    })
                }
            }

        })
    }

    render() {
        let { shortLeave, leaveTypes, allUsers } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Select User',
                    key: 'userId',
                    type: 'select',
                    options: allUsers,
                    showSearch: true,
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            userId: v
                        })
                    }
                },
                {
                    label: 'Start Date',
                    key: 'startDate',
                    type: 'date',
                    required: true,
                    customProps: {
                        onChange: (value) => {
                            this.fetchLeaveTypes(value);
                        }
                    },
                },
                {
                    label: 'Leave Type',
                    key: 'leaveType',
                    type: 'select',
                    options: leaveTypes,
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ leaveType: v })
                        if (v === 'HD(Half Day)') {
                            this.setState({ shortLeave: true })
                        } else {
                            this.setState({ shortLeave: false })
                        }
                    }
                },

                {
                    label: 'Start Time',
                    key: 'startTime',
                    type: 'time',
                    format: 'HH:MM:SS',
                    hidden: !shortLeave,
                    required: shortLeave,
                },
                {
                    label: 'End Date',
                    key: 'endDate',
                    type: 'date',
                    required: true,
                },
                {
                    label: 'End Time',
                    key: 'endTime',
                    type: 'time',
                    hidden: !shortLeave,
                    required: shortLeave,
                },
                {
                    label: 'Reason',
                    key: 'leaveReason',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Status',
                    key: 'status',
                    type: 'select',
                    required: true,
                    options: ['Pending', 'Approved', 'Disapproved'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })
                    }
                }
            ]
        }

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Leave Application Form
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddStaffLeave)
